// @flow
const configProd = {
  name: 'configProd',
  baseName: '',
  oldDomainUrl: 'https://zoom-ops.rivigo.com/#/',
  oldReactDomainUrl: 'https://zoom-ops.rivigo.com/',
  zoomApiUrl: 'https://zoom-api.rivigo.com',
  clientIntegrationApiUrl: 'https://client-integration-api.rivigo.com',
  loginUrl: 'https://login.rivigo.com/sso/login?client_id=zoom-panel',
  login: 'https://login.rivigo.com',
  logoutUrl: 'https://login.rivigo.com',
  zoomCommunicationsEp: 'https://zoom-communication.rivigo.com',
  analyticsFlag: true,
  analyticsId: 'UA-109460587-1',
  ticketingUrl: 'https://pace.rivigo.com/#/',
  zoomSuperSetUrl: 'http://zoom-superset.stg.rivigo.com',
  developerUrl: 'https://developer.rivigo.com',
  zoomWmsBaseUrl: 'https://zoom-wms.rivigo.com',
  vendorContractUrl: 'https://compass-vcm-api.rivigo.com',
  eRetailUrl: 'eretail.rivigo.com',
  crmOzoneTelCall:
    'https://api1.cloudagent.in/CAServices/AgentManualDial.php?api_key=#apiKey&username=#userName&campaignName=#campaignName&agentID=#emailId&customerNumber=#mobileNumber&uui=#uuid',
  crmGoogleForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSdzb5XrYgi8kCnQqnaRY5OG5-WSr_f7c2AX_aXHiCarOo-bjw/viewform?entry.842941686=#uuid&entry.2081758639=#name',
  mapBoxAccessToken:
    'pk.eyJ1Ijoicml2aWdvdGVjaCIsImEiOiJjazc0dGFtOTkwcDlqM2RudnJ3ODZ1bGZtIn0.cHBuD8CwIJK10-1DlYRy1Q',
  shipUrl: 'https://ship.rivigo.com/'
};

export default configProd;
